import { render, staticRenderFns } from "./AddRoom.vue?vue&type=template&id=3aa7c95c&"
import script from "./AddRoom.vue?vue&type=script&lang=js&"
export * from "./AddRoom.vue?vue&type=script&lang=js&"
import style0 from "./AddRoom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports